// extracted by mini-css-extract-plugin
export default {"contentCardMarginFix":"InquiryListModal_contentCardMarginFix__zkabx","tableWrapper":"InquiryListModal_tableWrapper__d4o1r"};